export enum CustomBlocksType {
  PRODUCT_RECOMMENDATION = 'product_recommendation',
}
